module.exports = __webpack_public_path__ + "static/media/incantation.65d8ff15.jpg";